import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './login.component';

@Injectable()
export class LoginModalService {
    private isOpen = false;

    constructor(private modalService: NgbModal) {
    }

    public open(): NgbModalRef {
        if (this.isOpen) {
            return;
        }

        this.isOpen = true;
        const modalRef = this.modalService.open(LoginComponent, {
            container: 'nav'
        });

        modalRef.result.then((result) => {
            this.isOpen = false;
        }, (reason) => {
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/login/login-modal.service.ts